import 'components/units/UnitDefinitionsAndMasks';
import { unit } from 'mathjs';

export const hasOperationValue = (value) => value !== undefined && value !== null && value !== '';

const convertCapacityValue = (value, fromUnit, toUnit) => {
  if (!hasOperationValue(value) || !fromUnit || !toUnit || fromUnit === toUnit) {
    return value;
  }

  try {
    return unit(value, fromUnit).toNumber(toUnit);
  } catch (_) {
    return '';
  }
};

export const itemValueOrEmpty = (itemData, csvName) => {
  if (!csvName) {
    return '';
  }
  const value = itemData[csvName];
  return hasOperationValue(value) ? value : '';
};

export const getUsableCapacityInitialValue = ({
  itemData,
  fillingStatus,
  usableCapacityCsv,
  totalCapacityCsv,
  usableCapacityUnit,
  totalCapacityUnit,
}) => {
  if (!usableCapacityCsv) {
    return '';
  }
  const usableCapacity = itemValueOrEmpty(itemData, usableCapacityCsv);
  if (hasOperationValue(usableCapacity)) {
    return usableCapacity;
  }
  if (fillingStatus === 'full') {
    const totalCapacity = itemValueOrEmpty(itemData, totalCapacityCsv);
    return convertCapacityValue(totalCapacity, totalCapacityUnit, usableCapacityUnit);
  }
  return '';
};

export const getFullCapacityDisplay = (formValues) => {
  const usableCapacity = formValues?.usableCapacity;
  if (hasOperationValue(usableCapacity?.value)) {
    return {
      value: usableCapacity.value,
      unit: usableCapacity.unit,
    };
  }

  const totalCapacity = formValues?.totalCapacity;
  return {
    value: hasOperationValue(totalCapacity?.value) ? totalCapacity.value : '',
    unit: totalCapacity?.unit || usableCapacity?.unit || 'L',
  };
};
